import React from 'react';
import { Icon, getPaymentProviderIconByName } from '@fourthwall/components';
import { PaymentPlaceholderIcon } from '@fourthwall/icons';
export const CreditCardIcon = ({ brand, size = 32 }) => {
    const icon = getPaymentProviderIconByName(brand) || PaymentPlaceholderIcon;
    return React.createElement(Icon, { component: icon, height: size });
};
